import PropTypes from 'prop-types';
// @mui
import Box from '@mui/material/Box';
import ButtonBase from '@mui/material/ButtonBase';
import Tooltip from '@mui/material/Tooltip';
import Typography from '@mui/material/Typography';
import { alpha } from '@mui/material/styles';

import { ATTENTION_TILES, isTileActive, tileCounts } from './caseload';

// ----------------------------------------------------------------------

// The row of counts at the top of the caseload (#612, #613). Each tile applies
// its filter to the table when clicked; clicking the one that is on clears it.
// A fixed grid, so the tiles stay one size and never leave one on its own row.

const CaseloadTiles = ({ rows, filters, onApply, onClear }) => {
  const counts = tileCounts(rows);

  return (
    <Box
      sx={{
        display: 'grid',
        gap: 1.5,
        gridTemplateColumns: { xs: 'repeat(2, 1fr)', sm: 'repeat(3, 1fr)', lg: `repeat(${ATTENTION_TILES.length}, 1fr)` },
      }}
    >
      {ATTENTION_TILES.map((tile) => {
        const active = isTileActive(tile, filters);
        const count = counts[tile.id];
        return (
          <Tooltip key={tile.id} title={tile.hint} placement="top" enterDelay={400}>
            <ButtonBase
              onClick={() => (active ? onClear() : onApply(tile))}
              aria-pressed={active}
              sx={(theme) => ({
                display: 'block',
                textAlign: 'left',
                px: 2,
                py: 1.5,
                borderRadius: 1.5,
                border: `1px solid ${active ? theme.palette[tile.color].main : theme.palette.divider}`,
                bgcolor: active ? alpha(theme.palette[tile.color].main, 0.08) : 'background.paper',
                '&:hover': { bgcolor: alpha(theme.palette[tile.color].main, 0.08) },
              })}
            >
              <Typography variant="h4" component="div" sx={{ color: count ? `${tile.color}.main` : 'text.disabled' }}>
                {count}
              </Typography>
              <Typography variant="body2" color="text.secondary" noWrap>
                {tile.label}
              </Typography>
            </ButtonBase>
          </Tooltip>
        );
      })}
    </Box>
  );
};

CaseloadTiles.propTypes = {
  rows: PropTypes.array.isRequired,
  filters: PropTypes.object.isRequired,
  onApply: PropTypes.func.isRequired,
  onClear: PropTypes.func.isRequired,
};

export default CaseloadTiles;
